
import { formatWithCommas } from "@/utils/helper";

export function toFixed(value) {
  if (value === 0) return (+value).toFixed(2);
  if (value == "" || value == undefined) return "";
  return formatWithCommas((+value).toFixed(2));
}

export function formatAccount(account) {
  return account && account.length > 10
    ? account.substring(0, 6) + "****" + account.substring(account.length - 4)
    : account;
}

export function formatHash(hash) {
  if (!hash) return "--";
  return hash.substring(0, 12) + "****" + hash.substring(hash.length - 12);
}

export function formatDate(time, Delimiter) {
  Delimiter = Delimiter || '/';
  if(typeof time === 'string' && time.indexOf('-') > 0){
	  var now = new Date(time);
  } else {
	  var now = new Date(time * 1000);
  }

  var year = now.getFullYear() + '';
  var month = now.getMonth() + 1 + '';
  var date = now.getDate() + '';
  var hour = now.getHours() + '';
  var minute = now.getMinutes() + '';
  var second = now.getSeconds() + '';

  month = month.length < 2 ? '0' + month : month;
  date = date.length < 2 ? '0' + date : date;
  hour = hour.length < 2 ? '0' + hour : hour;
  minute = minute.length < 2 ? '0' + minute : minute;
  second = second.length < 2 ? '0' + second : second;

  // return month + Delimiter + date + Delimiter + year + " " + hour + ":" + minute + ":" + second;
  return month + Delimiter + date + " " + hour + ":" + minute + ":" + second;
}